// 产品详情页折叠开始

document.querySelectorAll('.collapsible').forEach(panel => {
    const header = panel.querySelector('.collapsible-header');
    const icon = panel.querySelector('.collapsible-icon');
    
    // 初始化图标状态
    if (panel.classList.contains('active')) {
        icon.textContent = '-';
    }
    
    // 添加点击事件
    header.addEventListener('click', () => {
        // 切换active类
        panel.classList.toggle('active');
        
        // 更新图标和文本
        if (panel.classList.contains('active')) {
            icon.textContent = '-';
        } else {
            icon.textContent = '+';
        }
    });
});
// 产品详情页折叠结束
function xyzHasId(id) {
  return document.getElementById(id) != null;
}

// 示例
const collection_textContent_exists = xyzHasId('collection_textContent');
if(collection_textContent_exists){
    document.addEventListener('DOMContentLoaded', function() {
            const textContent = document.getElementById('collection_textContent');
            const readMoreBtn = document.getElementById('collection_readMoreBtn');
            
            // 检测文本是否超过指定行数
            function isTextOverflow(element, lineCount) {
                const lineHeight = parseInt(getComputedStyle(element).lineHeight);
                const contentHeight = element.scrollHeight;
                return contentHeight > lineHeight * lineCount;
                
            }
            
            // 初始化按钮显示
            if (!isTextOverflow(textContent, 3)) {
                readMoreBtn.style.display = 'none';
            }
            
           
            // 切换展开/收起状态
            readMoreBtn.addEventListener('click', function() {
                textContent.classList.toggle('collapsed');
                
                if (textContent.classList.contains('collapsed')) {
                    readMoreBtn.innerHTML = 'Read more <span class="icon"></span>';
                    readMoreBtn.classList.remove('expanded');
                } else {
                    readMoreBtn.innerHTML = 'Read less <span class="icon"></span>';
                    readMoreBtn.classList.add('expanded');
                }
            });
            
            // 防止滚动穿透
            readMoreBtn.addEventListener('touchstart', function(e) {
                e.stopPropagation();
            }, { passive: true });
        });
}


